/* tslint:disable */

/* eslint-disable */

/**
 * Title
 * Title
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {
    CountryInfo,
    CountryInfoFromJSON,
    Event,
    EventFromJSON,
    Message,
    MessageFromJSON,
    UpdateUserProfileRequest,
    UpdateUserProfileRequestToJSON,
    UserProfile,
    UserProfileFromJSON,
} from '../models';
import * as runtime from '../runtime';

export interface AddEmailAddressRequest {
    emailAddress: string;
    returnTo?: string;
}

export interface LogEventRequest {
    requestBody?: { [key: string]: object };
}

export interface RequestVerifyEmailRequest {
    returnTo?: string;
}

export interface UpdateProfileRequest {
    updateUserProfileRequest?: UpdateUserProfileRequest;
}

/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * Add email address
     */
    async addEmailAddressRaw(requestParameters: AddEmailAddressRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError(
                'emailAddress',
                'Required parameter requestParameters.emailAddress was null or undefined when calling addEmailAddress.'
            );
        }

        const queryParameters: any = {};

        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }

        if (requestParameters.returnTo !== undefined) {
            queryParameters['returnTo'] = requestParameters.returnTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('bearerAuth', []);

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request(
            {
                path: `/api/auth/add-email`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Add email address
     */
    async addEmailAddress(emailAddress: string, returnTo?: string, initOverrides?: RequestInit): Promise<Message> {
        const response = await this.addEmailAddressRaw({ emailAddress: emailAddress, returnTo: returnTo }, initOverrides);
        return await response.value();
    }

    /**
     * Get user profile
     */
    async getProfileRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserProfile>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('bearerAuth', []);

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request(
            {
                path: `/api/auth/me`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => UserProfileFromJSON(jsonValue));
    }

    /**
     * Get user profile
     */
    async getProfile(initOverrides?: RequestInit): Promise<UserProfile> {
        const response = await this.getProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Log event
     */
    async logEventRaw(requestParameters: LogEventRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Event>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request(
            {
                path: `/api/log-event`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.requestBody,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => EventFromJSON(jsonValue));
    }

    /**
     * Log event
     */
    async logEvent(requestBody?: { [key: string]: object }, initOverrides?: RequestInit): Promise<Event> {
        const response = await this.logEventRaw({ requestBody: requestBody }, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve list of countries
     */
    async rentalsListCountriesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CountryInfo>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/rentals/countries`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CountryInfoFromJSON));
    }

    /**
     * Retrieve list of countries
     */
    async rentalsListCountries(initOverrides?: RequestInit): Promise<Array<CountryInfo>> {
        const response = await this.rentalsListCountriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Send verification email
     */
    async requestVerifyEmailRaw(requestParameters: RequestVerifyEmailRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Message>> {
        const queryParameters: any = {};

        if (requestParameters.returnTo !== undefined) {
            queryParameters['returnTo'] = requestParameters.returnTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('bearerAuth', []);

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request(
            {
                path: `/api/auth/request-verify-email`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Send verification email
     */
    async requestVerifyEmail(returnTo?: string, initOverrides?: RequestInit): Promise<Message> {
        const response = await this.requestVerifyEmailRaw({ returnTo: returnTo }, initOverrides);
        return await response.value();
    }

    /**
     * Update user profile
     */
    async updateProfileRaw(requestParameters: UpdateProfileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserProfile>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('bearerAuth', []);

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request(
            {
                path: `/api/auth/me`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateUserProfileRequestToJSON(requestParameters.updateUserProfileRequest),
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => UserProfileFromJSON(jsonValue));
    }

    /**
     * Update user profile
     */
    async updateProfile(updateUserProfileRequest?: UpdateUserProfileRequest, initOverrides?: RequestInit): Promise<UserProfile> {
        const response = await this.updateProfileRaw({ updateUserProfileRequest: updateUserProfileRequest }, initOverrides);
        return await response.value();
    }
}
